const SendIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.2017 11.9406C23.2129 12.801 22.7468 13.5918 21.99 14.0069L4.35247 23.6974C3.56248 24.1439 2.63123 24.089 1.88683 23.5807C1.12877 23.0638 0.740768 21.8334 0.952679 20.9447L2.59922 14.0464C2.76825 13.339 3.40133 12.8409 4.12968 12.844L13.9449 12.8745C14.4475 12.8846 14.8552 12.4769 14.8451 11.9743C14.8435 11.4802 14.4419 11.0786 13.9393 11.0685L4.11473 11.0457C3.38639 11.0443 2.7502 10.544 2.57678 9.83556L0.872021 2.90977C0.665035 2.09134 0.901022 1.27429 1.47849 0.696819C1.54643 0.628881 1.62286 0.552454 1.69935 0.493061C2.44719 -0.0838833 3.4266 -0.157515 4.2628 0.288048L21.9601 9.88378C22.7195 10.2865 23.1905 11.0802 23.2017 11.9406Z"
        fill="#57585C"
      />
    </svg>
  );
};

export default SendIcon;
